import { useEffect, useState } from 'react';
import { LDProps } from 'launchdarkly-react-client-sdk/lib/withLDConsumer';
import { RouteProps } from 'react-router-dom';
import { IAPIPackage } from '../../commonUtils/APIContext';
import { IframeComponent } from '@hcecbp/uiintegrationcomponent';
import './AssetModelling.scss';
import { authService } from '../../../auth/services/authService';
import { IOrganisationState } from '../../../modules/commonUtils/Redux/Global/globalShared';
import { useSelector } from "react-redux";
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Button, Icon, Loader } from '@scuf/common';
import { useHistory } from 'react-router-dom';
import i18next from "i18next";
import { IUserState } from '../../commonUtils/Redux/Global/globalShared';

interface IAssetModellingProps extends LDProps, RouteProps, IAPIPackage {}

export const AssetModelling = (props: IAssetModellingProps) => {
  const featureFlags = useFlags();
  const history = useHistory();
  const trustedOrigin = (window as any).ENV.DF_BASE_URL;
  const getTheme = () => localStorage.getItem('COLOR_THEME') || '0';  
  const getLocale = () => i18next.language || 'en-US';
  const getIframeElement = () => document.getElementById('data-fabric-iframe') as HTMLIFrameElement;
  const orgSelected = useSelector((state: IOrganisationState) => state.globalShared.gatewaySelectedOrganisation);
  const organisationList = useSelector((state: IOrganisationState) => state.globalShared.organisationList);  
  const enableRolePrivilegesForSIOrg = useSelector((state: IOrganisationState) => state.globalShared.enableRolePrivilegesForSIOrg);
  const userProfile = useSelector((state: IUserState) => state.globalShared.userList);

  const [isIFrameLoaded, setIsIFrameLoaded] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [showContent, setShowContent] = useState<boolean|null>(null);

  useEffect(() => {
  if (enableRolePrivilegesForSIOrg === undefined) {
    return;
  } 
  
  if (organisationList.length > 0) {
    const isDistributor = orgSelected?.orgType?.toLowerCase() === 'distributor';
    let enableAssetModelingForSIOrg = false;

    enableAssetModelingForSIOrg = organisationList.some((item) =>
      (item.zuoraAccountNo !== null && item.orgType?.toLowerCase() !== 'distributor') ||
      (featureFlags['enableBacsFlowDistributor'] && item.orgType?.toLowerCase() === 'contractor')
    );
    const isContainSiOrg = enableAssetModelingForSIOrg && enableRolePrivilegesForSIOrg;
    setShowContent(isContainSiOrg && !isDistributor);
    setLoading(false);
  } 
 
}, [enableRolePrivilegesForSIOrg, organisationList, orgSelected]);


  const sendAppContextToIframe = () => {   
    const iframe = getIframeElement();
    if(iframe && iframe.contentWindow) {      
      const viewType = {
        type: 'appContext',
        theme: getTheme(),
        locale: getLocale(),
        userProfile
      };
      iframe.contentWindow.postMessage(viewType, trustedOrigin);
    }
  }

  useEffect(() => {
    if (isIFrameLoaded) {
      sendAppContextToIframe();
    }
  }, [isIFrameLoaded,
    i18next.language,
    localStorage.getItem('COLOR_THEME')
  ]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'requestToken') {
        if (event.origin === trustedOrigin) {
          authService
            .getTokenDetails()
            .then(tokenDetails => {
              const message = {
                type: 'responseToken',
                token: tokenDetails.access_token,
                id_token: tokenDetails.id_token,
                expires_at: tokenDetails.expires_at,
              };
              (event.source as Window).postMessage(message, event.origin);
            })
            .catch(err => {
              console.error('Error getting token:', err);
            });
        } else {
          console.error('Untrusted origin:', event.origin);
        }
      }
      if (event.data.type === 'appLoaded') {
        if (event.origin === trustedOrigin) {
          setIsIFrameLoaded(true);
        } else {
          console.error('Untrusted origin:', event.origin);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [trustedOrigin]);

  const integrationCustomer = 'RBM';
  const url = new URL((window as any).ENV.DF_BASE_URL);
  url.searchParams.append('integration_customer', integrationCustomer);

  if (loading) {
    return <Loader />;
  }

  return (<>
    {showContent === true ? (
      <div className="data-fabric-widget">
        <IframeComponent
          url={url.href}
          showLoader={true}
          width="100%"
          height="100%"
          id="data-fabric-iframe"
        />
      </div>
    ) : showContent === false ? (
      <div className="no-access-container">
        <div className="no-access-content">
          <Icon name="badge-warning" size="xlarge" />
          <h1 id="headerPageNotFound">{i18next.t('noPermissionText')}</h1>
          <Button
            className="routeToHomeButton"
            onClick={() => history.push('/app/feature/home')}
            type="secondary"
            content={i18next.t('home')}
          />
        </div>
      </div>
    ) : null}
  </>)
};

export default AssetModelling;
